import { isExpEditor } from '../lib/lib'
import Swiper from 'swiper/bundle'

class bookingCalender {
  constructor(element) {
    if (!element) {
      return false
    }

    if (isExpEditor()) {
      return false
    }

    this.strip = jQuery(element)

    const swiper = new Swiper(this.strip.find('.swiper')[0], {
      centeredSlides: false,
      breakpoints: {
        320: {
          slidesPerView: 3.75,
          spaceBetween: 8,
        },
        576: {
          slidesPerView: 5.75,
          spaceBetween: 8,
        },
        992: {
          slidesPerView: 7,
          spaceBetween: 8,
        },
      },
      navigation: {
        nextEl: '.b-calender__next-btn',
        prevEl: '.b-calender__prev-btn',
      },
    })
  }
}

export default bookingCalender
